/* @flow */

export const FETCH_DEPLOYMENTS: string = 'FETCH_DEPLOYMENTS';
export const FETCH_DEPLOYMENTS_SUCCESS: string = 'FETCH_DEPLOYMENTS_SUCCESS';
export const FETCH_DEPLOYMENTS_FAILURE: string = 'FETCH_DEPLOYMENTS_FAILURE';
export const DEPLOY: string = 'DEPLOY';
export const DEPLOY_SUCCESS: string = 'DEPLOY_SUCCESS';
export const DEPLOY_FAILURE: string = 'DEPLOY_FAILURE';

export const fetchDeployments = () => ({
  type: FETCH_DEPLOYMENTS,
});

export const deploy = () => ({
  type: DEPLOY,
});



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/deployments.js